// Module
var code = "<div layout=row style=overflow-y:hidden;height:100%> <imposition-detailed-template layout=column style=height:100%;width:100% details-type=\"'aroundImpp'\" schema-only=true open-from-composer=true></imposition-detailed-template> </div> ";
// Exports
module.exports = code;